import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import "../stylesheet/prescription.css";
import "../stylesheet/forms.css";
import Topnav from "../components/others/Topnav";
import { BsCheck } from "react-icons/bs";
import PatientForm from "../components/patient/forms/PatientForm";
import AppointmentSummary from "../components/appointments/AppointmentSummary";
import AppointmentTask from "../components/appointments/AppointmentTask";
import AppointmentStepBar from "../components/appointments/AppointmentStepBar";
import PatientSearch from "../components/patient/utils/PatientSearch";
import ContextApi from "../context/ContextApi";
import NewAppointment from "../components/patient/Details/appointments/NewAppointment";
import { getSelectedAppointment } from "../Utils/localStore";
import WStepper from "../components/utils/WizardStepper";

const CreateNewAppointment = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryParams = searchParams.get("mode");
  const [step, setStep] = useState(1);
  const [appointment, setAppointment] = useState({});
  const [task, setTask] = useState(null);
  const [currentPatient, setCurrentPatient] = useState(null);
  const [appointmentCreated, setAppointmentCreated] = useState(false);
  const goto = async () => {
    await getSelectedAppointment().then((resp) => {
      setCurrentPatient(resp[0].user);
      setAppointment(resp[0]);
    });
    if (queryParams == "summary") {
      setStep(3);
    } else if (queryParams == "edit") {
      setStep(2);
    }
  };
  useEffect(() => {
    console.log(queryParams);
    if (localStorage.getItem("apptEdit") === "true") {
      goto();
    }
  }, []);
  const handleContinue = () => {
    setStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setStep((prevStep) => prevStep - 1);
  };

  const gotSelectedPatient = (data) => {
    setCurrentPatient(data);
  };

  return (
    <div className="new">
      <Topnav />
      <div className="">
        <div className="w-full flex items-center justify-center my-6">
          <WStepper
            currentTab={step}
            config={[
              {
                name: "Patient details",
                status: "",
              },
              {
                name: "Appointment & Delegation",
                status: "Completed",
              },
              {
                name: "Summary",
                status: "Completed",
              },
            ]}
          />
        </div>

        <ContextApi.Provider
          value={{
            currentPatient,
            appointment,
            task,
            setAppointment,
            step,
          }}
        >
          <div>
            <div className="flex justify-center mx-auto w-full">
              {step === 1 && (
                <div className={"w-full lg:w-[700px]"}>
                  {currentPatient ? (
                    <>
                      <div className="w-full flex justify-center text-center mt-10">
                        <span
                          className="p-4 capitalize cursor-pointer text-center lg:text-left"
                        >
                          {" "}
                          Selected Patient Name:
                          <p>
                            <span className=" text-primary font-medium text-2xl">
                              {currentPatient?.patientName}
                            </span>
                          </p>
                        </span>
                      </div>
                    </>
                  ) : (
                    <div className="text-center">
                      <p className="mt-10">
                        Please enter an existing Patient's name to book an
                        appointment
                      </p>
                      <PatientSearch
                        className="mt-10"
                        SelectedPatient={gotSelectedPatient}
                      />
                      <p className="mt-10">Or rather</p>

                      <p>Click button below to create a new Patient</p>
                      <button
                        onClick={() => {
                          localStorage.setItem("patientEditMode", false);
                          navigate("/patients/new-patient");
                        }}
                        className="active bg-primary p-3 px-5 mt-5 rounded-full text-white"
                      >
                        Create New Patient
                      </button>
                    </div>
                  )}

                  {
                    <>
                      {currentPatient && (
                        <div className="w-full flex justify-center">
                          <button
                            className="border-primary border text-primary mb-4 p-2 w-36 rounded ml-3"
                            onClick={(e) => {
                              e.preventDefault();
                              setCurrentPatient(null);
                            }}
                          >
                            Change Patient
                          </button>
                          <button
                            className="bg-primary text-white mb-4 p-2 w-36 rounded ml-3"
                            onClick={(e) => {
                              e.preventDefault();
                              setStep(2);
                            }}
                          >
                            Continue
                          </button>
                        </div>
                      )}
                    </>
                  }
                </div>
              )}
              {step === 2 && (
                <NewAppointment
                  classes={"w-full lg:w-[700px]"}
                  type="fresh"
                  details={currentPatient}
                  oldAppointment={appointment}
                  onContinue={handleContinue}
                  onBack={() => setStep(1)}
                />
              )}
              {/* {step === 3 && (
                <AppointmentTask
                  onContinue={handleContinue}
                  onBack={handleBack}
                />
              )} */}
              {step === 3 && <AppointmentSummary onBack={handleBack} />}
            </div>
          </div>
        </ContextApi.Provider>
      </div>
    </div>
  );
};

export default CreateNewAppointment;
